/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
  },
  {
    url: "/locations",
    name: "Standorte",
    slug: "locations",
    icon: "MapPinIcon",
  },
  {
    url: "/events",
    name: "Flohmärkte",
    slug: "events",
    icon: "CalendarIcon",
  },
  {
    url: "/reservations/pending",
    name: "Unbest. Reservierungen",
    slug: "pending",
    icon: "GridIcon",
  },
  /*{
    url: "/reservations/approved",
    name: "Bestätigte Reservierungen",
    slug: "approved",
    icon: "GridIcon",
  },*/
  {
    url: "/contents",
    name: "Home-Inhalte",
    slug: "contents",
    icon: "EditIcon",
  },
  {
    url: "/customers",
    name: "Kunden",
    slug: "customers",
    icon: "UsersIcon",
  },
  {
    url: "/admins",
    name: "Dashboard-Benutzer",
    slug: "admins",
    icon: "UserCheckIcon",
  },
  {
    url: "/impressum",
    name: "Impressum",
    slug: "impressum",
    icon: "MessageSquareIcon",
  },
  {
    url: "/datenschutz",
    name: "Datenschutz",
    slug: "datenschutz",
    icon: "ShieldIcon",
  },
  {
    url: "/agb",
    name: "AGB",
    slug: "agb",
    icon: "AlertCircleIcon",
  },
  {
    url: "/payment",
    name: "Zahlungsinformationen",
    slug: "payment",
    icon: "DollarSignIcon",
  },
  {
    url: "https://www.flohmarktkoenig.ch/checkin",
    name: "Check in",
    slug: "external",
    icon: "CheckIcon",
    target: '_blank'
  },
]
